import { jsx, css } from '@emotion/react';
import { connectLocation } from "../../location/LocationConnectors";

import MarqueeFeatures from './oc-marquee-features';
import FormattedTable from './oc-formatted-table';

const styles = css`
  table {
    border-spacing: 0;
    width: 100%;

    th, td {
      border-color: #BCBCBC;
      border-collapse: collapse;
      border-right: 1px solid #BCBCBC;

      padding: 10px 15px;

      &:last-of-type {
        border-right: none;
      }
    }

    th {
      border-top: 2px solid #BCBCBC;
      border-bottom: 2px solid #BCBCBC;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #BCBCBC;

      &:nth-of-type(1) {
        text-align: left;
      }
    }

    tr:nth-of-type(1n) {
      td {
        background-color: none;
      }
    }

    tr:nth-of-type(2n) {
      td {
        background-color: #F8F8F8;
      }
    }
  }
`;

const TechnicalInformationTable = connectLocation(({ t, contents, heading, intro, anchor, bulletPoints, withMedia }) => (
  <section css={styles}>
    <FormattedTable contents={contents} heading={heading} intro={intro} anchor={anchor} />
    <MarqueeFeatures bulletPoints={ bulletPoints } withMedia={ withMedia } hasMainItems={ true } />
  </section>
));

export default TechnicalInformationTable;

